/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Email_InvalidInputs */

const en_signin_email_invalid = /** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an email address, for example name@company.com.`)
};

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const ar_signin_email_invalid = en_signin_email_invalid;

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const he_signin_email_invalid = en_signin_email_invalid;

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const ur_signin_email_invalid = en_signin_email_invalid;

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const es_signin_email_invalid = en_signin_email_invalid;

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const fr_signin_email_invalid = en_signin_email_invalid;

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const de_signin_email_invalid = en_signin_email_invalid;

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const pt_signin_email_invalid = en_signin_email_invalid;

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const hi_signin_email_invalid = en_signin_email_invalid;

/** @type {(inputs: Signin_Email_InvalidInputs) => LocalizedString} */
const bn_signin_email_invalid = en_signin_email_invalid;

/**
* | output |
* | --- |
* | "Enter an email address, for example name@company.com." |
*
* @param {Signin_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_email_invalid = /** @type {((inputs?: Signin_Email_InvalidInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Email_InvalidInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_email_invalid(inputs)
	if (locale === "he") return he_signin_email_invalid(inputs)
	if (locale === "ur") return ur_signin_email_invalid(inputs)
	if (locale === "es") return es_signin_email_invalid(inputs)
	if (locale === "fr") return fr_signin_email_invalid(inputs)
	if (locale === "de") return de_signin_email_invalid(inputs)
	if (locale === "pt") return pt_signin_email_invalid(inputs)
	if (locale === "hi") return hi_signin_email_invalid(inputs)
	if (locale === "bn") return bn_signin_email_invalid(inputs)
	return /** @type {LocalizedString} */ ("Enter an email address, for example name@company.com.")
});